import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal, Stack } from "@mui/material";
import { BIGrey, BILightGrey } from "../../../../assets/helpers";
import { GetType } from "../GetFileType";
import AudioViewer from "./AudioViewer";
import OtherFileViewer from "./OtherFileViewer";
import PdfViewer from "./PdfViewer";
import PictureViewer from "./PictureViewer";
import VideoViewer from "./VideoViewer";
import { useSelector } from "react-redux";

function SiteFilePreview({ open, handleClose, file, showDetails }) {
   const { selectedClientData } = useSelector((state) => state?.main);
  const getSpecificViewer = () => {
    switch (GetType(file.name)) {
      case "video":
        return <VideoViewer showDetails={showDetails ?? true} file={file} />;
      case "audio":
        return <AudioViewer showDetails={showDetails ?? true} file={file} />;
      case "pdf":
        return <PdfViewer showDetails={showDetails ?? true} file={file} />;
      case "image":
        return <PictureViewer showDetails={showDetails ?? true} file={file} />;
      default:
        return (
          <OtherFileViewer showDetails={showDetails ?? true} file={file} />
        );
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-add-client-support"
        aria-describedby="modal-add-client"
      >
        <Box className="client-modal-responsive">
          <Stack direction={"row"} sx={{ justifyContent: "flex-end" }}>
            <IconButton size="small" onClick={handleClose} sx={{ color:selectedClientData?.AccentColor !==undefined &&selectedClientData?.AccentColor ? selectedClientData?.AccentColor : BILightGrey }}>
              <CloseIcon />
            </IconButton>
          </Stack>
          {getSpecificViewer()}
        </Box>
      </Modal>
    </div>
  );
}

export default SiteFilePreview;
